export default __webpack_public_path__ + "static/media/central_andes_2_7.6544b923.JPG";